// @flow
/* eslint arrow-parens:0 */

import type { Action } from 'app/common/redux/types';

export type State = {
  current: ?string,
  initial: ?string,
  locationToErrorMap: Object,
  upwtActionName: ?number,
};

const initialState = {
  initial: null,
  current: null,
  locationToErrorMap: {},
  upwtActionName: null,
};

const mainComponent = (state: State = initialState, action: Action): State => {
  if (action.type === 'SET_MAIN_COMPONENT') {
    return {
      ...state,
      current: action.payload.name,
    };
  } else if (action.type === 'SET_INIT_MAIN_COMPONENT') {
    return {
      ...state,
      initial: action.payload.name,
    };
  } else if (action.type === 'SET_LOCATION_TO_ERROR_MAP_ENTRY') {
    const locationToErrorMap = { ...state.locationToErrorMap };
    locationToErrorMap[action.payload.pathname] = action.payload.renderError;
    return {
      ...state,
      locationToErrorMap,
    };
  } else if (action.type === 'UNSET_LOCATION_TO_ERROR_MAP_ENTRY') {
    const locationToErrorMap = { ...state.locationToErrorMap };
    delete locationToErrorMap[action.payload.pathname];
    return {
      ...state,
      locationToErrorMap,
    };
  } else if (action.type === 'SET_UPWT_ACTION_NAME') {
    return {
      ...state,
      upwtActionName: action.payload.name,
    };
  }
  return state;
};

export default mainComponent;
